import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CustomDataGrid from "../ReusableComponent/DataGrid/CustomizeDataGrid";
import access_ControlStore from "../../Stores/Access_ControlStores";
import Access_ControlConstants from "../../Constants/Access_ControlConstants";
import Access_ControlActions from "../../Actions/Access_ControlActions";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../Context/LanguageContext";

export default function ViewChecklist({ anlageid, isOpen, setViewChecklist }) {
  const [open, setOpen] = React.useState(isOpen);
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState("md");
  const [checklist, setChecklist] = useState([]);
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  const columns = [
    {
      field: "pruefPlanName",
      headerName: localization.name,
      hideable: false,
      flex: 1,
    },
    {
      field: "duration",
      headerName: localization.duration,
      hideable: false,
      flex: 1,
    },
    {
      field: "frequency",
      headerName: localization.frequency,
      hideable: false,
      flex: 1,
    },
    {
      field: "lastCheck",
      headerName: localization.lastCheckDate,
      hideable: false,
      flex: 1,
    },
    {
      field: "nextCheck",
      headerName: localization.nextCheckDate,
      hideable: false,
      flex: 1,
    },
  ];

  useEffect(() => {
    setGlobalSpinner(true);
    Access_ControlActions.GetAnlageLastInspections(anlageid);
  }, [anlageid]);

  const handleClose = () => {
    setOpen(false);
    setViewChecklist(false);
  };

  useEffect(() => {
    function getAnlageLastInspectionSuccess() {
      const res = access_ControlStore.getAnlageLastInspectionDetails();
      if (res.length > 0) {
        let temp = res.map((item, index) => {
          item["id"] = index;
          item["frequency"] =
            item.frequency.toLowerCase() === "y"
              ? localization.year
              : item.frequency.toLowerCase() === "m"
              ? localization.month
              : item.frequency.toLowerCase() === "a"
              ? localization.anytime
              : localization.day;
          return item;
        });
        setChecklist(temp);
      } else {
        setChecklist([]);
      }
      setGlobalSpinner(false);
    }

    function getAnlageLastInspectionFailure() {
      const res = access_ControlStore.getAnlageLastInspectionDetails();
      setGlobalSpinner(false);
    }
    access_ControlStore.addChangeListener(
      Access_ControlConstants.GET_ANLAGE_LAST_INSPECTION_SUCCESS,
      getAnlageLastInspectionSuccess
    );

    access_ControlStore.addChangeListener(
      Access_ControlConstants.GET_ANLAGE_LAST_INSPECTION_FAILURE,
      getAnlageLastInspectionFailure
    );
    return () => {
      access_ControlStore.removeChangeListener(
        Access_ControlConstants.GET_ANLAGE_LAST_INSPECTION_SUCCESS,
        getAnlageLastInspectionSuccess
      );

      access_ControlStore.removeChangeListener(
        Access_ControlConstants.GET_ANLAGE_LAST_INSPECTION_FAILURE,
        getAnlageLastInspectionFailure
      );
    };
  }, []);

  return (
    <React.Fragment>
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>{localization.checklists}</DialogTitle>
        <DialogContent>
          <DialogContentText style={{ fontSize: "14px" }}>
            {localization.viewAndManageChecklists} #
            {sessionStorage.getItem("invnr")}
          </DialogContentText>

          {checklist && (
            <CustomDataGrid
              Title=""
              columns={columns}
              rows={checklist}
              operations={""}
              onAdd={""}
              showExport={false}
              showColumns={false}
              showFilters={false}
              showDensity={false}
              visibleColumns={[]}
              showCheckBox={false}
              gridTableHeight={"dataGridLarge"}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            sx={{ textTransform: "none" }}
            onClick={handleClose}
          >
            {localization.close}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
